import { Preferences } from "@capacitor/preferences";
import * as Sentry from "@sentry/react";

// TODO(MEIS-12500): migrate to @capacitor-community/secure-storage-plugin so
// the refresh token is stored in Keychain / Keystore instead of plain
// Preferences (NSUserDefaults / SharedPreferences).
const STORAGE_KEY = "keycloak-tokens";

export interface StoredKeycloakTokens {
  token: string;
  refreshToken: string;
  idToken?: string;
}

function isStoredKeycloakTokens(value: unknown): value is StoredKeycloakTokens {
  if (typeof value !== "object" || value === null) return false;
  const v = value as Record<string, unknown>;
  if (typeof v.token !== "string" || v.token.length === 0) return false;
  if (typeof v.refreshToken !== "string" || v.refreshToken.length === 0)
    return false;
  if (v.idToken !== undefined && typeof v.idToken !== "string") return false;
  return true;
}

export const keycloakCapacitorTokenStorage = {
  async read(): Promise<StoredKeycloakTokens | null> {
    try {
      const { value } = await Preferences.get({ key: STORAGE_KEY });
      if (!value) return null;
      const parsed: unknown = JSON.parse(value);
      return isStoredKeycloakTokens(parsed) ? parsed : null;
    } catch (e) {
      Sentry.captureException(e);
      return null;
    }
  },

  async write(tokens: StoredKeycloakTokens): Promise<void> {
    try {
      await Preferences.set({
        key: STORAGE_KEY,
        value: JSON.stringify(tokens),
      });
    } catch (e) {
      Sentry.captureException(e);
    }
  },

  async clear(): Promise<void> {
    try {
      await Preferences.remove({ key: STORAGE_KEY });
    } catch (e) {
      Sentry.captureException(e);
    }
  },
};
